import React from "react";
import {
  Hero,
  Benefits,
  InsuranceScope,
  DownloadDocuments,
  Disclaimer,
  ContactForm,
  ScrollToSection,
} from "agronomist-ui-components";

import PageTemplate from "../helpers/PageTemplate";
import { getBreadcrumbs } from "../helpers/fakeBreadcrumbs";
import TempShareButtonsComponent from "../helpers/TempShareButtonsComponent";
import { scrollToElement } from "../helpers/utils";

import imageUrl from "../assets/images/kredyt_34.png";
import fileA from "../../assets/prf/pdf/02 Generali Gospodarstwo Rolne Karta produktu.pdf";
import fileB from "../../assets/prf/pdf/03 Generali Gospodarstwo Rolne Ustandaryzowany dokument.pdf";
import fileC from "../../assets/prf/pdf/04 Generali Gospodarstwo Rolne OWU.pdf";

const COPY = {
  HERO: {
    breadcrumbs: getBreadcrumbs("Ubezpieczenie zwierząt gospodarskich"),
    title: "Ubezpieczenie zwierząt gospodarskich",
    description:
      "Poszukujesz najlepszej ochrony ubezpieczeniowej dla Twoich zwierząt gospodarskich? Skorzystaj z możliwości ubezpieczenia z dotacją z budżetu państwa aż do 65% składki z polisy.",
    imageUrl,
    button: {
      title: "Sprawdź ofertę",
      onClick: () => scrollToElement("#ofert"),
    },
  },
  BENEFITS: {
    title: "Dlaczego warto ubezpieczyć zwierzęta gospodarskie?",
    subtitle:
      "Gdyż ryzyka takie jak pożar, awaria urządzeń wentylacyjnych, eksplozja, porażenie prądem czy anomalie pogodowe mogą być przyczyną śmierci zwierząt i są trudne do przewidzenia.",
    benefits: [
      {
        title: "Dopłata do składki z budżetu państwa dla wariantu podstawowego",
        icon: "MoneyPlus",
      },
      {
        title:
          "Możliwość ubezpieczenia zwierząt dodatkowo od ognia, eksplozji i porażenia prądem",
        icon: "PaperShield",
      },
      {
        title:
          "Wypłata odszkodowania w sytuacji uboju z konieczności w następstwie zdarzeń opisanych w zakresie ubezpieczenia",
        icon: "HandCoins",
      },
    ],
  },
  BENEFITS2: {
    title: "Jak to działa?",
    subtitle:
      "Kredytomat to prosta i przyjazna wyszukiwarka oferty bankowej ułatwiająca dobór produktów najbardziej dopasowanych do Twoich potrzeb związanych z prowadzeniem gospodarstwa rolnego.",
    benefits: [
      {
        title: "Znajdź ubezpieczenie spełniające Twoje oczekiwania",
        description:
          "Ustaw interesujące Cię kryteria wyszukiwania, aby otrzymać ofertę jak najbardziej dopasowaną do Twoich potrzeb.",
        icon: "SearchBulb",
      },
      {
        title: "Skontaktuj się z nami",
        description:
          "Zapisz propozycję oferty i pozostaw swoje dane kontaktowe aby porozmawiać z Ekspertem ds. Ubezpieczeń lub odwiedź nas w Banku BNP.",
        icon: "MessagesBulb",
      },
      {
        title: "Gotowe! Możesz realizować swoje potrzeby",
        description:
          "Formalności załatwimy drogą elektroniczną, abyś Ty mógł spokojnie i bezpiecznie prowadzić  gospodarstwo",
        icon: "HandBulb",
      },
    ],
    withArrow: true,
  },
  DOWNLOAD_DOCUMENTS: {
    title: "Dokumenty do pobrania",
    files: [
      {
        name: "Karta produktu",
        details: "Produkt 2021, Plik .pdf 0.4mb",
        url: fileA,
      },
      {
        name: "Ustandaryzowany dokument",
        details: "Produkt 2021, Plik .pdf 0.4mb",
        url: fileB,
      },
      {
        name: "Ogólne Warunki Ubezpieczenia",
        details: "Produkt 2021, Plik .pdf 0.4mb",
        url: fileC,
      },
    ],
  },
  DISCLAIMER: {
    notes: [
      "Treści zawarte na niniejszej stronie mają charakter wyłącznie reklamowy i informacyjny oraz nie stanowią oferty w rozumieniu Kodeksu Cywilnego. Świadczenie ochrony ubezpieczeniowej następuje na warunkach określonych w umowie zawartej z Klientem za pośrednictwem Banku BNP Paribas, działającego jako agent ubezpieczeniowy, przez Generali Towarzystwo Ubezpieczeń S.A. oraz w Ogólnych Warunkach Ubezpieczeń. Szczegółowe warunki ubezpieczenia, w tym ograniczenia i wyłączenia odpowiedzialności z nimi związane, jak również informacje na temat zasad działania poszczególnych produktów i kosztów z nimi związanych określone są w obowiązujących dla danego produktu Ogólnych Warunkach Ubezpieczenia, przekazywanych każdorazowo klientowi przed zawarciem umowy ubezpieczenia. Generali Towarzystwo Ubezpieczeń S.A. z siedzibą w Warszawie przy ul. Postępu 15B, zarejestrowana w rejestrze przedsiębiorców prowadzonym przez Sąd Rejonowy dla m.st. Warszawy, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS 10623, kapitał zakładowy 191.000.000 PLN wpłacony w całości, NIP 526-23-49-108, należąca do Grupy Generali, figurującej w Rejestrze Grup Ubezpieczeniowych prowadzonym przez IVASS.",
    ],
  },
  INSURANCE_SCOPE_1: {
    title: "Przedmiot ubezpieczenia",
    items: [
      "bydło",
      "świnie",
      "owce i kozy",
      "konie",
      "drób (kury, indyki, kaczki, gęsi, przepiórki, perlice, strusie)",
    ],
    icon: "Cows",
  },
  INSURANCE_SCOPE_2: {
    title: "Zakres ubezpieczenia",
    description: "Szeroki zakres ochrony na rynku, w tym:",
    items: [
      "huragan, powódź, deszcz nawalny, grad, uderzenie pioruna",
      "obsunięcie się ziemi, lawina",
      "ubój z konieczności, który jest następstwem w/w zdarzeń",
      "akcje ratownicze, wyburzenie, odgruzowanie lub zanieczyszczenie i skażenie spowodowane w/w zdarzeniami",
    ],
    icon: "TodoListHand",
    bg: "green",
    iconBg: "white",
    isReversed: true,
  },
  INSURANCE_SCOPE_3: {
    title: "Zalety ubezpieczenia",
    description: "Rolnicy cenią sobie:",
    items: [
      "szeroki katalog gatunków zwierząt objętych ubezpieczeniem",
      "możliwość ochrony zwierząt od następnego dnia po wystawieniu polisy",
      "ochronę zwierząt w budynkach inwentarskich, na placach i wybiegach",
      "brak okresu karencji i bardzo szybki proces zawarcia polisy",
      "brak konieczności ubezpieczenia budynków w Generali",
    ],
    icon: "CowsShield",
    bg: "white",
    iconBg: "orange",
  },
};

const UbezpieczeniaMieniaZwierzeta = () => (
  <PageTemplate
    meta={{
      name: "Kredytomat",
      description:
        "Potrzebujesz finansowania, dotknęła Cię klęska żywiołowa, a może szukasz ubezpieczenia dla swojego gospodarstwa rolnego? Pomożemy Ci - Agronomist",
      mediaCoverUrl: imageUrl,
    }}
  >
    <Hero {...COPY.HERO} />
    <Benefits {...COPY.BENEFITS} pt="4rem" pb="4rem" />
    <InsuranceScope {...COPY.INSURANCE_SCOPE_1} id="ofert" />
    <InsuranceScope {...COPY.INSURANCE_SCOPE_2} />
    <InsuranceScope {...COPY.INSURANCE_SCOPE_3} />
    <ScrollToSection
      onClick={() => {
        window.location.href = `/kredytomat/kontakt?product_url=${
          window.location.pathname
        }&product_name=Ubezpieczenie zwierząt gospodarskich`;
      }}
      text="Zapytaj o ofertę"
    />
    <TempShareButtonsComponent />
    <Benefits withArrow {...COPY.BENEFITS2} pt="4rem" pb="4rem" />
    <DownloadDocuments {...COPY.DOWNLOAD_DOCUMENTS} />
    <Disclaimer {...COPY.DISCLAIMER} />
    <ContactForm id="contact" />
  </PageTemplate>
);

export default UbezpieczeniaMieniaZwierzeta;
